import React, { useState, useEffect } from "react";
import "./thankyou.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { updategameover, getScore, updateReport } from "../../scoreservice";
import { sendReport, extractReportIdFromResponse, resolveReportRole } from "../../functions/sendReport";

function Thankyou({ updateHeader }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, SetriddlerusLogo] = useState("/img/thankyou-gif.gif");
  const storedUserData = JSON.parse(sessionStorage.getItem('userData') || 'null');
  const stateFromGame = location.state; // { points, time } when navigating from game

  const [textcolor, Setcolorcode] = useState(null);
  const [score, setScore] = useState(() => stateFromGame?.points ?? 0);
  const [time, setTime] = useState(() => (stateFromGame?.time != null && stateFromGame?.time !== '') ? stateFromGame.time : null);
  const [fetchError, setFetchError] = useState(false);
  const [playedTime, setPlayedTime] = useState(() => (stateFromGame?.time != null && stateFromGame?.time !== '') ? stateFromGame.time : "00:00");
  const handleSuccess = (msg) => {
    return Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: msg,
      confirmButtonText: 'OK',
      customClass: { popup: 'custom-success-popup' }
    });
  };

  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  const calculatePlayedTime = (themeTimer, remainingTime) => {

    if (!themeTimer || !remainingTime) return "00:00";

    let totalSeconds = 0;
    let remainingSeconds = 0;

    // convert theme timer (mm:ss)
    if (typeof themeTimer === "string" && themeTimer.includes(":")) {

      const [min, sec] = themeTimer.split(":");

      totalSeconds =
        Number(min || 0) * 60 +
        Number(sec || 0);

    } else {

      totalSeconds = Number(themeTimer) * 60;

    }

    // convert remaining time (mm:ss)
    if (typeof remainingTime === "string" && remainingTime.includes(":")) {

      const [min, sec] = remainingTime.split(":");

      remainingSeconds =
        Number(min || 0) * 60 +
        Number(sec || 0);

    } else {

      remainingSeconds = Number(remainingTime);

    }

    const playedSeconds = totalSeconds - remainingSeconds;

    const minutes = Math.floor(playedSeconds / 60);
    const seconds = playedSeconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };


  const handleError = (msg) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: msg,
      customClass: { popup: 'custom-success-popup' }
    });
  };

  useEffect(() => {

    updateHeader({
      backButtonRedirect: "/game"
    });

    const fetchData = async () => {
      const storedSession = sessionStorage.getItem("userData");
      console.log(storedSession);
      const storedTheme = sessionStorage.getItem("themeData");

      if (storedSession && storedTheme) {
        const parsedUser = JSON.parse(storedSession);
        const parsedTheme = JSON.parse(storedTheme);

        setUserData(parsedUser);
        setThemeData(parsedTheme);
        Setcolorcode(parsedTheme.landing_page_title_color);
        console.log("Theme Rules:", parsedTheme.rules);
      } else {
        navigate("/login"); // Redirect if session data is missing
      }
    };

    fetchData();
  }, [navigate]);

  useEffect(() => {
    if (themeData?.game_title?.trim()) {
      document.title = themeData.game_title.trim();
    }
  }, [themeData]);

  useEffect(() => {

    if (!storedUserData?.sessionId) return;

    const fetchScore = async () => {
      try {
        const payload = {
          userId: storedUserData.userId || storedUserData.userid,
          sessionId: storedUserData.sessionId,
          organizationId: storedUserData.organizationId
        };

        const res = await getScore(payload);

        console.log("Full API response:", res);

        if (res?.status === "success") {
          console.log("totalscore-----", res.data.total_score);
          const apiScore = res.data.total_score ?? 0;
          const apiTime = res.data?.time ?? null;
          setScore(apiScore);
          setTime(apiTime);
          // Re-send time to DB when we have it from API (in case game's update failed or thank-you sent "00:00" before fetch)
          if (apiTime != null && apiTime !== "") {
            const timeToSend = String(apiTime).trim();
            const reportData = {
              sessionId: storedUserData.sessionId,
              organizationId: storedUserData.organizationId,
              userId: storedUserData.userId || storedUserData.userid,
              gameover: true,
              gamecomplete: true,
              time: timeToSend,
              points: apiScore
            };
            updategameover(reportData);
          }
        }
      } catch (err) {
        console.error("fetchScore error:", err);
      }
    };

    fetchScore();

  }, []);



  useEffect(() => {

    if (!storedUserData?.sessionId) return;
    // Only send when we have a real time (avoid overwriting DB with "00:00" before getScore returns)
    const timeToSend = playedTime || stateFromGame?.time || null;
    if (!timeToSend || timeToSend === "00:00") return;

    const pointsToSend = Number(score);

    // Same as the reference game: update the report when we have its id, otherwise add it now.
    const sendReportUpdate = async () => {
      try {
        const role = resolveReportRole(storedUserData);
        if (role === "demo") return;

        const response = await sendReport({
          role,
          token: storedUserData.token,
          reportId: storedUserData.reportId || storedUserData.reportid || storedUserData.report_id || undefined,
          gameId: storedUserData.gameId,
          name: storedUserData.name || "",
          sessionId: storedUserData.sessionId,
          organizationId: storedUserData.organizationId,
          userId: storedUserData.userId || storedUserData.userid,
          points: pointsToSend,
          time: timeToSend,
        });

        // a report was created just now (none existed): remember its id
        const newReportId = extractReportIdFromResponse(response);
        if (newReportId && newReportId !== String(storedUserData.reportId || "")) {
          const merged = { ...storedUserData, reportId: newReportId };
          sessionStorage.setItem("userData", JSON.stringify(merged));
          updateReport(merged);
        }
        console.log("Report sent successfully");
      } catch (error) {
        console.error("Report send failed:", error.response?.data || error);
      }
    };

    // Gameover API – update database with gamecomplete (always call when we have session)
    const reportData = {
      sessionId: storedUserData.sessionId,
      organizationId: storedUserData.organizationId,
      userId: storedUserData.userId || storedUserData.userid,
      gameover: true,
      gamecomplete: true,
      time: timeToSend,
      points: pointsToSend
    };
    updategameover(reportData);
    
    sendReportUpdate();

  }, [playedTime, score]);


  useEffect(() => {

    if (!themeData) return;

    const convertToSeconds = (val) => {
      if (val == null || val === "" || String(val) === "undefined") return 0;
      const str = String(val).trim();
      if (!str) return 0;
      if (str.includes(":")) {
        const parts = str.split(":").map(Number);
        if (parts.length === 2) return parts[0] * 60 + parts[1];
        if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
      }
      const n = Number(str);
      return isNaN(n) ? 0 : n;
    };

    const timerStr = themeData.timer?.trim();
    if (timerStr && time != null && themeData.use_timeout === "1") {

      const remainingSeconds = convertToSeconds(time);
      const totalSeconds = convertToSeconds(timerStr);

      if (remainingSeconds <= 1) {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = Math.floor(totalSeconds % 60);
        setPlayedTime(
          `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
        );
      } else {
        const playedSeconds = Math.max(0, totalSeconds - remainingSeconds);
        const minutes = Math.floor(playedSeconds / 60);
        const seconds = Math.floor(playedSeconds % 60);
        setPlayedTime(
          `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
        );
      }

    } else if (time != null && time !== "") {
      const t = String(time).trim();
      if (t) setPlayedTime(t);
    } else if (timerStr) {
      setPlayedTime(timerStr);
    }

  }, [themeData, time]);



  useEffect(() => {

    if (!themeData) return;

    const body = document.body;

    const updateBackground = () => {

      if (!body.classList.contains("common-bg")) return;

      const isMobile = window.innerWidth <= 768;
      const isPortrait = window.matchMedia("(orientation: portrait)").matches;

      if (isMobile && isPortrait) {
        body.style.backgroundImage = `url(${themeData.background_mob})`;
      } else {
        body.style.backgroundImage = `url(${themeData.background_desk})`;
      }
    };

    updateBackground(); // initial
    window.addEventListener("resize", updateBackground);

    return () => {
      window.removeEventListener("resize", updateBackground);
    };

  }, [themeData]);


  const displayTimer = playedTime ?? themeData?.timer ?? "00:00";

  return (
    <>
      <div className="thankyou-main-container" style={{ textAlign: "center" }}>
        <div className="thankyou-main-container1" style={{ textAlign: "center" }}>
          <img src={riddlerusLogo} className="login-logo1" alt="Logo" />
        </div>
        <div>
          <div className="main_text_ty" style={{ color: textcolor }}>
            <strong>{themeData?.custom_text_thank_you_page}</strong>
            <br />
          </div>

          <p className="score" style={{ margin: "10px 0", color: textcolor }}>
            You have scored <strong>{score}</strong> in <strong>{displayTimer}</strong> minutes.
          </p>
        </div>
      </div>
    </>
  );
}
export default Thankyou;